export default function dataWrapperMessageListener() {
  window.addEventListener('message', (node) => {
    if ('undefined' !== typeof node.data['datawrapper-height']) {
      Object.keys(node.data['datawrapper-height']).forEach((key) => {
        const iframe = document.getElementById(`datawrapper-chart-${key}`);

        if (iframe) {
          iframe.style.height = `${node.data['datawrapper-height'][key]}px`;
        }
      });
    }
  });
}
